export default __webpack_public_path__ + "static/media/cfirst-claim-4mar26final.47d6f4fa.png";